// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module__header___2BDXs","clearAll":"styles-module__clearAll___1DYnF","visits":"styles-module__visits___21fcg"};